import { Outlet } from "react-router-dom";

const ChargerInstallationList = () => {
  return (
    <div>
      <Outlet />
    </div>
  );
};

export default ChargerInstallationList;
